import { createWeb3Modal } from '@web3modal/wagmi/react'
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config'
import { chains } from './constant'
import { createConfig } from 'wagmi'


const projectId = process.env.REACT_APP_PROJECT_ID
const metadata = {
  name: process.env.REACT_APP_PROJECT_NAME,
  description: process.env.REACT_APP_PROJECT_DESC,
  url: process.env.REACT_APP_PROJECT_URL,
  icons: [process.env.REACT_APP_PROJECT_ICON]
}


export const config = createConfig({
  chains
})

export const wagmiConfig = defaultWagmiConfig({
    chains, // required
    projectId, // required
    metadata, // required
  })
createWeb3Modal({ wagmiConfig, projectId, chains , 
    themeVariables: {
        '--w3m-color-mix': `#${process.env.REACT_APP_CONNECT_MODAL_COLOR_CODE}`,
        '--w3m-color-mix-strength': 20
      }
})